import type { IconData } from '@stacksjs/iconify-core'

export const iMedicalLibrary: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M15.111 8.293V1.618H8.436v6.675H1.761v6.675h6.675v6.674h6.675v-6.674h6.675V8.293zm21.065 20.719c4.605 0 8.341-3.739 8.341-8.343a8.34 8.34 0 0 0-8.341-8.34a8.34 8.34 0 0 0-8.341 8.34c0 4.603 3.736 8.343 8.341 8.343m-13.065 34.51V56.12l-7.423 2.066a4.7 4.7 0 0 1-1.755.338a4.757 4.757 0 0 1-3.942-7.414l11.907-16.327c1.293-1.77 3.098-3.743 6.905-3.743h14.395c3.805 0 5.612 1.973 6.903 3.743L62.008 51.11a4.758 4.758 0 0 1-3.94 7.414a4.7 4.7 0 0 1-1.755-.338l-7.425-2.066v7.402zM36 58.351l9.619-3.183l-.217-.06c-6.636-1.953-4.052-10.721 2.583-8.763l.907.305v-9.902L36 40.96l-12.891-4.212v9.902l.902-.305c6.64-1.958 9.224 6.81 2.584 8.763l-.213.06z\"/>",
  "width": 64,
  "height": 64,
  "viewBox": "0 0 64 64"
}

export default iMedicalLibrary
